module.exports = __webpack_public_path__ + "img/Ppogo.c5ab48d4.jpg";